// @flow strict

import * as React from 'react';
import cs from 'classnames';
/* eslint-disable-next-line css-modules/no-unused-class */
import styles from './styles.scss';

type LinkItem = {|
  Identifier: string,
  LinkText: string,
|};

type JumpLinkTheme = 'Dark' | 'CitrusContrast' | 'Citrus' | 'Light' | 'Neutral' | 'DarkNeutral';

type PropTypes = {|
  jumpLinks: Array<LinkItem>,
  theme?: JumpLinkTheme,
|};

function getJumpLinkWrapperClassname(theme: JumpLinkTheme = 'Citrus') {
  return cs(styles['jump-links__wrapper'], styles[`jump-links__wrapper--${theme}`]);
}
// function getTriggerClassname(theme: JumpLinkTheme = 'Citrus') {
//   return cs(styles['jump-links__trigger'], styles[`jump-links__trigger--${theme}`]);
// }

function getJumpLinkClassname(theme: JumpLinkTheme = 'Citrus') {
  return cs(styles['jump-links'], styles[`jump-links--${theme}`]);
}

function getItemContainerClassname(theme: JumpLinkTheme = 'Citrus') {
  return cs(styles['jump-links__item-container'], styles[`jump-links__item-container--${theme}`]);
}

export const JumpLinksBase = (props: PropTypes) => {
  const jumpLinks = React.useRef<HTMLDivElement | null>(null);

  // const [triggerText, setTriggerText] = React.useState(<>&nbsp;</>);

  const detectFixedJumpLink = React.useCallback(() => {
    if (!jumpLinks.current) return;

    if ((jumpLinks.current.getBoundingClientRect().top || 0) - 62 < 0) {
      // eslint-disable-next-line no-unused-expressions
      if (jumpLinks.current) {
        jumpLinks.current.classList.add(styles.fixed);
      }
      return;
    }

    // eslint-disable-next-line no-unused-expressions
    if (jumpLinks.current) {
      jumpLinks.current.classList.remove(styles.fixed);
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener('scroll', detectFixedJumpLink);

    return () => {
      document.removeEventListener('scroll', detectFixedJumpLink);
    };
  }, [detectFixedJumpLink]);

  const maxHeight = `calc(${props.jumpLinks.length || 0} * 50px)`;

  const handleJumpItemClick = (index: number) => (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const anchor: LinkItem = props.jumpLinks[index];

    // setTriggerText(anchor.LinkText);

    // eslint-disable-next-line unicorn/prefer-query-selector
    const target = document.getElementById(anchor.Identifier || '');
    if (!target) return;

    const headerOffset = 83;
    const top = Math.max(target.offsetTop - headerOffset, 0);

    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top,
      });
    }, 0);
  };

  return (
    <div ref={jumpLinks} className={getJumpLinkClassname(props.theme)}>
      <div className={getJumpLinkWrapperClassname(props.theme)}>
        {/* <div className={styles['jump-links__dropdown']}> */}
        {/* <div
            role="button"
            tabIndex={0}
            onKeyDown={() => null}
            className={getTriggerClassname(props.theme)}
          >
            {triggerText}
          </div> */}

        <div className={getItemContainerClassname(props.theme)} style={{ maxHeight }}>
          {props.jumpLinks.map((anchor, index) => (
            <div
              role="button"
              tabIndex={0}
              onKeyDown={() => null}
              onClick={handleJumpItemClick(index)}
              className={styles['jump-links__item']}
              key={anchor.Identifier}
            >
              <a href={`#${anchor.Identifier}`}>{anchor.LinkText}</a>
            </div>
          ))}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const JumpLinks = (props: PropTypes) => <JumpLinksBase {...props} />;

JumpLinks.defaultProps = {
  theme: 'Citrus',
};

export default JumpLinks;
